import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=07644e41&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=07644e41&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07644e41')) {
      api.createRecord('07644e41', component.options)
    } else {
      api.reload('07644e41', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=07644e41&", function () {
      api.rerender('07644e41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/investigate/statistical/edit.vue"
export default component.exports